import React from 'react';
import { BriefsTable } from './components/BriefsTable';

export const BriefsTab: React.FC = () => {
  return (
    <div className="p-8 bg-secondary w-full">
      <BriefsTable />
    </div>
  );
};
